module.exports = __webpack_public_path__ + "img/undertakingCases23.b3d8d796.jpg";